import { render } from "./CreditsShare.vue?vue&type=template&id=12b83b98&scoped=true"
import script from "./CreditsShare.vue?vue&type=script&lang=js"
export * from "./CreditsShare.vue?vue&type=script&lang=js"

import "./CreditsShare.vue?vue&type=style&index=0&id=12b83b98&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b83b98"]])

export default __exports__